import * as React from "react"
import { SVGProps } from "react"

const CheckmarkIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} {...props} viewBox={"0 0 16 16"}>
        <g data-name="Group 1329" transform="translate(10361.389 -4533.612)">
            <circle
                data-name="Ellipse 43"
                cx={8}
                cy={8}
                r={8}
                transform="translate(-10361.389 4533.612)"
                fill="#21bf2d"
            />
            <path
                data-name="Path 471"
                d="m-10357.806 4541.617 3.332 3.332 5.425-5.425"
                fill="none"
                stroke="#fff"
                strokeWidth={2}
            />
        </g>
    </svg>
)

export default CheckmarkIcon
